import React, { Fragment, useContext } from 'react';
import { FormBlock } from '../../types/general';
import * as Schema from '../../types/schema';
import { LocaleContext } from 'src/app/LocaleProvider';
import Field from './Field';
import { Form } from 'react-bootstrap';

function LocalizedField(props: FormBlock<Schema.Field>) {
	const { locale, locales } = useContext(LocaleContext);
	const { schema } = props;
	const { name, label, props: schemaProps } = schema;

	if (schemaProps && schemaProps.localized) {
		return (
			<Fragment>
				{locales && locales.length > 0 && (
					<Fragment>
						{locales.map((l) => {
							if (l.key !== locale?.key) return null;
							const newSchema = { ...schema, name: `${name}.${l.key}` };
							return <Field key={l.key} {...props} schema={newSchema} />;
						})}
					</Fragment>
				)}
				{!locales && (
					<Fragment>
						<Form.Label>{label}</Form.Label>
						<div className='lang-empty'>Nessuna lingua configurata</div>
					</Fragment>
				)}
			</Fragment>
		);
	}

	return <Field {...props} />;
}

export default LocalizedField;
